export default __webpack_public_path__ + "static/media/11.26f5c174.png";